export default class Plus {
  constructor(element) {
    this.element = element;
    this.textOpen = false;
    this.init();
  }

  init() {   
    this.element.addEventListener("click", this.openPlus.bind(this));
  }

  openPlus(){
    const container = this.element.closest('.texte-image__content');
    const hidden = container.querySelector('.hide');
    

    if(this.textOpen){
      hidden.style.height = '0';
      this.textOpen = false;
    }
    else{
      hidden.style.height = hidden.scrollHeight + 'px';
      this.textOpen = true;
    }
  }
}
